import React from 'react'
import Link from 'gatsby-link'

import styled, { css } from 'react-emotion'
import { colors } from '../../styles/vars'

const ImageOverlay = styled('div')`
  text-align: center;
  box-sizing: border-box;
  
  div {
    height: 190px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    background-image: url("${props => props.backgroundImage ? props.backgroundImage : ''}"); 
    background-size: cover;
    background-position: center;
    align-items: center;
    margin: 6px;
    display: flex;
    transition: all 0.15s ease-in-out;
    
    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(224, 39, 45, 0.75);
      z-index: 1; 
      transition: all 0.15s ease-in-out;
    }
  } 
 
   h3 {
    position: relative;
    z-index: 2;
    padding: 20px;
    margin: 0;
    flex: 1;
   }
   
   
`

const link = css`
   text-decoration: none;
   color: ${colors.white};
   align-self: center;
   
   &:hover {
      filter: drop-shadow(0px 0px 4px rgba(0,0,0,0.4));
      transition: all 0.15s ease-in-out;
      
      .image {
        height: 196px;
        margin: 0;
        transition: all 0.15s ease-in-out;
                
        &:after {
          border-radius: 4px;
          background-color: rgba(224, 39, 45, 0.95);
          transition: all 0.15s ease-in-out;
        }
      }
   }
`

export const Image = (props) =>
  <Link to={props.to} className={link}>
    <ImageOverlay backgroundImage={props.image}>
      <div className={"image"}>
        <h3>
          {props.children}
        </h3>
      </div>
    </ImageOverlay>
  </Link>



// WEBPACK FOOTER //
// ./src/components/Image/index.js